<template>
    <div class="solution-main">
        <!-- 头部 -->
      <headers></headers>

        <section class="ban">
            <div class="col">
                <div>
                    <h1 class="title1">主办解决方案</h1>
                    <p>为主办企业/协会提供多元化、标准化、高性价比的数字化办展解决方案。</p>
                </div>
            </div>
        </section>
        <div style="">
            <section class="col box-3" style="padding-top: 50px;">
                <h4 class="title3" style="margin-bottom: 30px;">核心优势</h4>
                <div class="list-hxys">
                    <dl>
                        <dt>智慧云服务</dt>
                        <dd>⼀站式数字化管理<br>
                            全⾯信息采集积累<br>
                            ⾼效项⽬协同办展<br>
                            线上线下融合发展</dd>
                    </dl>
                    <dl>
                        <dt>安全高效</dt>
                        <dd>严格的权限划分<br>
                            专业的流程规划<br>
                            直观的数据呈现<br>
                            安全的云端存储</dd>
                    </dl>
                    <dl>
                        <dt>专业服务</dt>
                        <dd>先进的运营理念<br>
                            专业的运营经验<br>
                            专业的研发团队<br>
                            一对一服务护航</dd>
                    </dl>
                </div>
            </section>
            <section class="col box-3" style="">
                <h4 class="title3" style="margin-bottom: 70px;">应用场景</h4>
                <div class="box-yycj">
                    <ul class="ul1" id="list-btn">
                        <li class="active">展前组展场景</li>
                        <li>展中布展场景</li>
                        <li>展商综合服务</li>
                    </ul>
                    <div class="div1">
                        <p class="p1" id="_title" style="border-bottom: none;">招展云+观众云</p>
                        <ul class="ul2" id="_list">
                            <li>·展商客户信息留存管理</li>
                            <li>·展刊信息收集管理</li>
                            <li>·观众登记表编辑发布</li>
                            <li>·观众信息留存</li>
                            <li>·观众数据分析</li>
                        </ul>
                    </div>
                    <div class="div2">
                        <div class="img-box">
                            <img id="_img" :src="require(`@/images/${image}`)" alt="">
                            <a class="a1" href="http://shop.exposcm.com/" target="_blank"></a>
                            <a class="a2" href="http://design.exposaas.com/" target="_blank"></a>
                        </div>
                        
                    </div>
                </div>
            </section>

            <section class="col box-3">
                <h4 class="title3" style="margin-bottom: 50px;">合作伙伴</h4>
                <ul class="brand-list">
                    <li><img src="../images/logo/36中食.jpg" alt=""></li>
                    <li><img src="../images/logo/37饲料.jpg" alt=""></li>
                    <li><img src="../images/logo/38餐饮.jpg" alt=""></li>
                    <li><img src="../images/logo/39零售.jpg" alt=""></li>
                    <li><img src="../images/logo/40特许加盟.jpg" alt=""></li>
                    <li><img src="../images/logo/41集约化畜牧.jpg" alt=""></li>
                    <li><img src="../images/logo/42畜牧.jpg" alt=""></li>
                    <li><img src="../images/logo/43成都健身.jpg" alt=""></li>
                    <li><img src="../images/logo/44混凝土.jpg" alt=""></li>
                    <li><img src="../images/logo/45烘培.jpg" alt=""></li>
                    <li><img src="../images/logo/46成都广告.jpg" alt=""></li>
                    <li><img src="../images/logo/47成都幼教.jpg" alt=""></li>
                </ul>
            </section>

            
        </div>
        <h4 class="title3" style="margin-bottom: 30px;margin-top: 100px;font-size: 26px;">服务联系</h4>
        <div class="box-fwlx">
            <section class="col box-3 ">
                <div class="box-fwlx-con">
                    <div class="div1">
                        <p>企微客服</p>
                        <img src="../images/img-kf.png" alt="">
                        <p>首席客服热线</p>
                        <span>010-86460766-861</span>
                    </div>
                    
                        <ul class="ul1">
                            <form id="form-zx2" action="">
                                <li class="li1">
                                    <label for="">公司名称</label>
                                    <input name="compnay" type="text" maxlength="50">
                                </li>
                                <li class="li1">
                                    <label for="">所在行业</label>
                                    <input name="industry" type="text" maxlength="30">
                                </li>
                                <li class="li1">
                                    <label for="">您的姓名</label>
                                    <input name="username" type="text" maxlength="20">
                                </li>
                                <li class="li1">
                                    <label for="">手机号码</label>
                                    <input name="phone" type="text">
                                </li>
                                <li>
                                    <label for="">咨询需求</label>
                                    <textarea name="content" id="" maxlength="200"></textarea>
                                </li>
                                <li>
                                    <a class="btn" id="btn-zx-sub2" href="javascript:;">立即发送</a>
                                </li>
                            </form>
                        </ul>
                    
                </div>
            </section>
        </div>
        <!-- 尾部 -->
      <footers></footers>
      <!-- 右侧吸附客服咨询按钮 -->
      <contact></contact>
    </div>
</template>
    <script>
    import $ from 'jquery';
    import headers from '@/common/header';
    import footers from '@/common/Footer';
    import contact from '@/components/contact';
    export default {
        components: {
            headers,
            footers,
            contact
        },
        data() {
            return {
                list:[{
                    label: '积累数据资产',
                    title: '招展云+观众云',
                    con: ['·展商客户信息留存管理','·展刊信息收集管理','·观众登记表编辑发布','·观众信息留存','·观众数据分析'],
                    img: 'img-3-1.png',
                    url: ''
                },{
                    label: '供应商管理',
                    title: '主场云+物流云',
                    con: ['·在线图纸申报','·⽔电预定与缴费','·货⻋进场管理','·⼈员实名认证登记','·现场“零接触”服务','·数字化安全巡查'],
                    img: 'img-3-2.png',
                    url: ''
                },{
                    label: '展商综合服务',
                    title: '招展云+设计云+会展商城',
                    con: ['·在线展位实时销售','·物料在线下单','·展刊资料在线收集','·合同线上管理','·海量展台样式挑选','·优秀搭建商案例展示供展商挑选','·展商物料印刷优惠'],
                    img: 'img-3-3.png',
                    url: ''
                }],
                image:'img-3-1.png'
            }
        },
        mounted() {
            let that = this
            $('#list-btn>li').on('click',function(){
                $(this).addClass('active').siblings('li').removeClass('active')
                var _index = $(this).index()
                console.log("uiou",_index);
                
                var item = that.list[_index]
                $('#_title').text(item.title)
                var html = ''
                for(var i=0,j=item.con.length; i<j; i++){
                    html += '<li>'+item.con[i]+'</li>'
                }
                $('#_list').html(html)
                that.image = item.img
                // $('#_img').attr('src',item.img)
                $('#_more').attr('href',item.url)

                if(_index == 2){
                    $('.img-box a').show()
                }else{
                    $('.img-box a').hide()
                }
            })
        }
    }
    </script>



// WEBPACK FOOTER //
// src/page/solution.vue